module.exports = __webpack_public_path__ + "img/9788954436427.796f1efa.jpg";